export enum FiberPlanStatus {
  FIBER_LIVE = 'FIBER_LIVE',
  FIBER_PRESALE = 'FIBER_PRESALE',
  FIBER_COMING_SOON = 'FIBER_COMING_SOON',
  FIBER_MDU_NURTURE = 'FIBER_MDU_NURTURE',
  FIBER_UNSERVICEABLE = 'FIBER_UNSERVICEABLE',
  FIBER_REGISTERED = 'FIBER_REGISTERED',
}

export enum ProductFamily {
  FIBER = 'Fiber',
  SATELLITE = 'Satellite',
}
